import { render, staticRenderFns } from "./HelpWithPayment.vue?vue&type=template&id=0c22c22a"
import script from "./HelpWithPayment.vue?vue&type=script&lang=js"
export * from "./HelpWithPayment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports